import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';
import Card from '@/components/common/Card';
import clientImage from '@/components/common/icons/client-details.svg';

const ClientCard = ({ data }) => {
  return (
    <Card 
      url={`/commercial/clients/${data?.id}`}
      className="group"
    >
      <div className="flex items-center">
        <div className="relative w-[2em] h-[2em] mr-[0.5em] text-[#45668c] leading-[0] shrink-0">
          <img src={clientImage} alt="Cliente" className="max-w-full max-h-full" />
        </div>
        <div className="relative top-[3px] text-[0.875em] leading-none font-bold text-[#393939] truncate !no-underline">
          {data?.name}
        </div>
      </div>
      {(data?.phone || data?.email) && (
        <div className="flex mt-[0.5em] text-[0.8125em] text-[#919191] !no-underline">
          {data?.phone && <div className="font-bold">{data?.phone}</div>}
          {data?.email && (
            <div className={cn(
              "font-semibold",
              data?.phone && "before:content-['•'] before:mx-[5px]"
            )}>
              {data?.email}
            </div>
          )}
        </div>
      )}
    </Card>
  );
};

ClientCard.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ClientCard;
